import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from 'react-router';
import { useAuth } from '../providers/AuthContext';
export function LoginGuard({ loadingFallback }) {
    const { loggedIn, isInitialized } = useAuth();
    if (!isInitialized) {
        return loadingFallback;
    }
    return loggedIn ? _jsx(Navigate, { to: "/", replace: true }) : _jsx(Outlet, {});
}
//# sourceMappingURL=login-guards.js.map